
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import LitigationContent from "@/components/expertise/LitigationContent";

const Litigation = () => {
  useEffect(() => {
    document.title = "AI Litigation & E-Discovery Solutions | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI litigation & e-discovery solutions. Predictive analytics, research tools & case insights. Gain your competitive advantage.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI litigation & e-discovery solutions. Predictive analytics, research tools & case insights. Gain your competitive advantage.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <LitigationContent />
      </div>
      <FooterSection />
    </>
  );
};

export default Litigation;
